import * as React from "react";
import { colors } from "@aifi-ml/design-system-variables";

interface ErrorWarningIconProps {
  color?: string;
  width?: number;
  height?: number;
}

export const ErrorWarningIcon: React.FC<ErrorWarningIconProps> = ({
  color = colors.light["color/icon/tag/error"],
  width = 40,
  height = 40,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 40 40"
    fill="none"
  >
    <path
      d="M37 29.3891L23.3359 5.65939C22.9945 5.07802 22.507 4.59598 21.9219 4.26104C21.3367 3.92611 20.6742 3.74991 20 3.74991C19.3258 3.74991 18.6633 3.92611 18.0781 4.26104C17.493 4.59598 17.0055 5.07802 16.6641 5.65939L3 29.3891C2.67146 29.9514 2.49832 30.5909 2.49832 31.2422C2.49832 31.8935 2.67146 32.533 3 33.0953C3.33708 33.6802 3.8237 34.1649 4.40994 34.4996C4.99617 34.8343 5.66091 35.007 6.33593 35H33.6641C34.3386 35.0065 35.0026 34.8335 35.5883 34.4988C36.1739 34.1641 36.6601 33.6797 36.9969 33.0953C37.3259 32.5333 37.4996 31.8939 37.5001 31.2426C37.5007 30.5914 37.3281 29.9517 37 29.3891ZM18.75 16.25C18.75 15.9185 18.8817 15.6005 19.1161 15.3661C19.3505 15.1317 19.6685 15 20 15C20.3315 15 20.6495 15.1317 20.8839 15.3661C21.1183 15.6005 21.25 15.9185 21.25 16.25V22.5C21.25 22.8315 21.1183 23.1495 20.8839 23.3839C20.6495 23.6183 20.3315 23.75 20 23.75C19.6685 23.75 19.3505 23.6183 19.1161 23.3839C18.8817 23.1495 18.75 22.8315 18.75 22.5V16.25ZM20 30C19.6292 30 19.2666 29.89 18.9583 29.684C18.65 29.478 18.4096 29.1852 18.2677 28.8425C18.1258 28.4999 18.0887 28.1229 18.161 27.7592C18.2334 27.3955 18.4119 27.0614 18.6742 26.7992C18.9364 26.537 19.2705 26.3584 19.6342 26.286C19.9979 26.2137 20.3749 26.2508 20.7175 26.3927C21.0601 26.5347 21.353 26.775 21.559 27.0833C21.765 27.3917 21.875 27.7542 21.875 28.125C21.875 28.6223 21.6775 29.0992 21.3258 29.4508C20.9742 29.8025 20.4973 30 20 30Z"
      fill={color}
    />
  </svg>
);
